import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { useTranslation } from "react-i18next";
import { RemainingRangeAddInData } from "@/models/RemainingRangeAddInData";

interface RemainingRangeCellProps {
  props: GridRenderCellParams;
}

export function RemainingRangeCell({ props }: RemainingRangeCellProps) {
  const { row } = props;
  const { t } = useTranslation();
  const remainingRange: RemainingRangeAddInData | undefined = row.remainingRange;
  const odometer: number | null | undefined = row.odometer;

  if (!remainingRange || odometer == null) {
    return <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>---</Box>;
  }

  const drivenSinceInput = (odometer - remainingRange.odometerAtInput) / 1000;
  const remaining = Math.max(0, remainingRange.inputKm - drivenSinceInput);

  const formattedValue = `${Math.round(remaining).toLocaleString("de-DE")} ${t("units.km")}`;
  const tooltipText = `${t("faultOverview.remainingRangeTooltip", {
    inputKm: remainingRange.inputKm.toLocaleString("de-DE"),
    driven: Math.round(drivenSinceInput).toLocaleString("de-DE"),
  })}`;

  return (
    <Tooltip title={tooltipText}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          height: "100%",
          color: remaining === 0 ? "error.main" : undefined,
          fontWeight: remaining === 0 ? "bold" : undefined,
        }}
      >
        {formattedValue}
      </Box>
    </Tooltip>
  );
}
